import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';

export enum TeamRostersReportFields {
  seatId = 'seatId',
  seatStatus = 'seatStatus',
  seatUpdatedOn = 'seatUpdatedOn',
  seatStartDate = 'seatStartDate',
  seatEndDate = 'seatEndDate',
  teamId = 'teamId',
  teamName = 'teamName',
  teamStartDate = 'teamStartDate',
  teamEndDate = 'teamEndDate',
  teamUpdatedBy = 'teamUpdated',
  teamUpdatedOn = 'teamUpdatedOn',
  teamCreatedBy = 'teamCreatedBy',
  teamCreatedOn = 'teamCreatedOn',
  teamStatus = 'teamStatus',
  personId = 'personId',
  personName = 'personName',
  personFirstName = 'personFirstName',
  personLastName = 'personLastName',
  personSuffix = 'personSuffix',
  personEmail = 'personEmail',
  personStatus = 'personStatus',
  personImageId = 'personImageId',
  positionTitle = 'positionTitle',
  personCompany = 'personCompany',
  personLinkedInProfile = 'personLinkedInProfile',
  personJobTitle = 'personJobTitle',
  personCandidateId = 'personCandidateId',
  personIsUnsubscribed = 'personIsUnsubscribed',
  streetAddress1 = 'streetAddress1',
  streetAddress2 = 'streetAddress2',
  city = 'city',
  state = 'state',
  country = 'country',
  postalCode = 'postalCode',
  phoneNumber = 'phoneNumber',
  personCustomFields = 'personCustomFields',
  personComplexCustomFields = 'personComplexCustomFields',
  teamCustomFields = 'teamCustomFields',
  trackedCustomFields = 'trackedCustomFields',
  races = 'races',
  gender = 'gender',
  personTags = 'personTags',
  teamWorkspaceId = 'teamWorkspaceId',
  personExternalSystemId = 'personExternalSystemId',
  invitationLink = 'invitationLink',
}

export const TeamRostersSystemColumns: ItemPickerModel[] = [
  new ItemPickerModel(TeamRostersReportFields.seatId, '', 'Position ID'),
  new ItemPickerModel(TeamRostersReportFields.seatStatus, '', 'Position Status'),
  new ItemPickerModel(TeamRostersReportFields.seatUpdatedOn, '', 'Position Update Date'),
  new ItemPickerModel(TeamRostersReportFields.seatStartDate, '', 'Seat Start Date'),
  new ItemPickerModel(TeamRostersReportFields.seatEndDate, '', 'Seat End Date'),
  new ItemPickerModel(TeamRostersReportFields.teamId, '', 'Team ID'),
  new ItemPickerModel(TeamRostersReportFields.teamName, '', 'Team'),
  new ItemPickerModel(TeamRostersReportFields.teamStartDate, '', 'Team Start Date'),
  new ItemPickerModel(TeamRostersReportFields.teamEndDate, '', 'Team End Date'),
  new ItemPickerModel(TeamRostersReportFields.teamUpdatedOn, '', 'Updated On'),
  new ItemPickerModel(TeamRostersReportFields.teamCreatedBy, '', 'Created By'),
  new ItemPickerModel(TeamRostersReportFields.teamCreatedOn, '', 'Created On'),
  new ItemPickerModel(TeamRostersReportFields.teamStatus, '', 'Team Status'),
  new ItemPickerModel(TeamRostersReportFields.personId, '', 'Person ID'),
  new ItemPickerModel(TeamRostersReportFields.personName, '', 'Person'),
  new ItemPickerModel(TeamRostersReportFields.personFirstName, '', 'Person First Name'),
  new ItemPickerModel(TeamRostersReportFields.personLastName, '', 'Person Last Name'),
  new ItemPickerModel(TeamRostersReportFields.personSuffix, '', 'Person Suffix'),
  new ItemPickerModel(TeamRostersReportFields.personEmail, '', 'Person Email'),
  new ItemPickerModel(
    TeamRostersReportFields.personExternalSystemId,
    '',
    'Person External System Id'
  ),
  new ItemPickerModel(TeamRostersReportFields.personStatus, '', 'Person Status'),
  new ItemPickerModel(TeamRostersReportFields.personCompany, '', 'Person Company'),
  new ItemPickerModel(TeamRostersReportFields.personJobTitle, '', 'Person Job Title'),
  new ItemPickerModel(TeamRostersReportFields.personLinkedInProfile, '', 'Person LinkedIn Address'),
  new ItemPickerModel(TeamRostersReportFields.gender, '', 'Gender'),
  new ItemPickerModel(TeamRostersReportFields.races, '', 'Race'),
  new ItemPickerModel(TeamRostersReportFields.personTags, '', 'Person Tags'),
  new ItemPickerModel(TeamRostersReportFields.positionTitle, '', 'Position Title'),
  new ItemPickerModel(TeamRostersReportFields.streetAddress1, '', 'Street Address 1'),
  new ItemPickerModel(TeamRostersReportFields.streetAddress2, '', 'Street Address 2'),
  new ItemPickerModel(TeamRostersReportFields.city, '', 'City'),
  new ItemPickerModel(TeamRostersReportFields.state, '', 'State'),
  new ItemPickerModel(TeamRostersReportFields.country, '', 'Country'),
  new ItemPickerModel(TeamRostersReportFields.postalCode, '', 'Postal Code'),
  new ItemPickerModel(TeamRostersReportFields.phoneNumber, '', 'Phone Number'),
  new ItemPickerModel(TeamRostersReportFields.invitationLink, '', 'Invitation Link'),
  new ItemPickerModel(TeamRostersReportFields.personIsUnsubscribed, '', 'Person  Email Preference'),
];
